import { Vue } from 'vue-property-decorator';

class StepBus extends Vue {

}

export default new StepBus();
